import { aiHelper } from './ai-helper';

export const parseTextareaToHtml = (textareaContent) => {
  // Convert literal \n strings (escaped newlines) to actual newlines first
  const normalizedContent = textareaContent?.replaceAll('\\n', '\n');
  const { beforeText, afterText, aiBlocks } = aiHelper(normalizedContent);
  if (aiBlocks?.length) {
    const beforeContent = beforeText?.replaceAll('\n', '<br>');
    const aftercontent = afterText?.replaceAll('\n', '<br>');
    return `<p>${beforeContent}</p><ai-personalized-block></ai-personalized-block><p>${aftercontent}</p>`;
  } else {
    const textareaContentWithBreaktag = normalizedContent?.replaceAll(
      '\n',
      '<br>'
    );
    return `<p>${textareaContentWithBreaktag}</p>`;
  }
};

export const parseHtmlToTextarea = (html) => {
  const htmlWithNewLine = html?.replaceAll('<br>', '\n');
  const dom = new DOMParser()?.parseFromString(
    htmlWithNewLine,
    'text/html'
  )?.documentElement;
  const paragraphs = dom?.getElementsByTagName('p');
  const paragraphTexts = [];
  for (let i = 0; i < paragraphs.length; i++) {
    const paragraph = paragraphs[i];
    paragraphTexts.push(paragraph?.textContent || '');
  }
  return paragraphTexts.join('');
};

export const htmlHasFormatting = (htmlString) => {
  const stylePatterns = [
    /<(b|strong)\b/i, // Bold
    /<(i|em)\b/i, // Italic
    /<u\b/i, // Underline
    /<(s|strike|del)\b/i, // Strikethrough
    /<h[1-4]\b/i, // Headings (h1-h4)
    /<(a)\b/i, // Links
    /<(ul|ol|li)\b/i, // Lists (unordered/ordered/items)
    /align\s*=\s*['"](left|right|center)['"]/i, // align attribute
    /style\s*=\s*['"][^'"]*text-align\s*:\s*(left|right|center)[^'"]*['"]/i, // inline style alignment
  ];

  return stylePatterns.some((pattern) => pattern.test(htmlString));
};


export const convertPlainTextToHtml = (content) => {
	if (!content) return '<p></p>';

	// Check if content already has HTML formatting
	if (htmlHasFormatting(content)) {
		return content;
	}

	// Split by newlines and wrap each line in a paragraph
	const lines = content.split('\n');
	const paragraphs = lines.map((line) => {
		// If line is empty, create an empty paragraph
		const trimmedLine = line.trim();
		return trimmedLine ? `<p>${line}</p>` : '<p></p>';
	});

	return paragraphs.join('');
};
